export function buyoutYBIValidate(res){
    var result = true;

    result = validateMonths(res.data.months);
    result = validateStates(res.data.states);

    return result;
}

function validateMonths(months) {
    return Array.isArray(months) && months.length == 3;
}

function validateStates(states) {
    var is_all_ok = true;

    for(var state of states){
        is_all_ok = (typeof state.name === 'string')
        && typeof state.is_total === 'boolean'
        && typeof state.months === 'object'

        if (is_all_ok == false) return false;
    }

    return is_all_ok;
}